import './sentry.js'; // Sentry must be imported first

import React from "react";
import ReactDOM from "react-dom/client";

// Tailwind CSS (required for all UI styling)
import "./index.css";

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import WireframeApp from "./WireframeApp.jsx";

// Determine redirect URI based on environment
const getRedirectUri = () => {
  if (typeof window !== 'undefined') {
    // Use current origin + base path for production/staging
    const pathname = window.location.pathname;
    if (pathname.startsWith('/staging/tracker')) {
      return window.location.origin + '/staging/tracker/';
    }
    if (pathname.startsWith('/tracker')) {
      return window.location.origin + '/tracker/';
    }
    return window.location.origin + '/';
  }
  return "http://localhost:5173";
};

// MSAL CONFIG — RESTORED FOR QUOTES + USER LOGIN
const msalConfig = {
  auth: {
    clientId: "94e27fb3-fd5b-4512-8c6b-9eb2b0310180",
    authority:
      "https://login.microsoftonline.com/2350508b-6d67-408a-9c55-c5040357d90d",
    redirectUri: getRedirectUri(),
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

// BACKEND API SCOPE — must match your "Expose an API" scope in Azure
export const backendApiScopes = [
  "api://2350508b-6d67-408a-9c55-c5040357d90d/b351e950-d526-4ee4-b95b-03f6ec89cd3d/access_as_user",
];

// Export login request with explicit redirect URI for popup login
export const loginRequest = {
  scopes: ["User.Read"],
  redirectUri: getRedirectUri(),
};

const pca = new PublicClientApplication(msalConfig);

// Keep track of whether we've already rendered - attach to window to survive HMR
if (!window.__REACT_ROOT__) {
  window.__REACT_ROOT__ = null;
}

// Initialize MSAL and handle any redirect response (including popup redirects)
async function initializeApp() {
  try {
    await pca.initialize();

    // Handle redirect promise - this processes the auth code after redirect
    const response = await pca.handleRedirectPromise();
    if (response) {
      console.log("MSAL redirect response received:", response);
    }

    // Only create root once - use window to survive HMR
    if (!window.__REACT_ROOT__) {
      window.__REACT_ROOT__ = ReactDOM.createRoot(document.getElementById("root"));
    }

    // Render the app after MSAL is fully initialized
    window.__REACT_ROOT__.render(
      <MsalProvider instance={pca}>
        <WireframeApp />
      </MsalProvider>
    );
  } catch (error) {
    console.error("MSAL initialization error:", error);
  }
}

initializeApp();
